import { useState } from "react";
import { Pagination } from "react-bootstrap";

import { ModuleItem } from "../ModuleItem/ModuleItem.jsx";
import { SwitchAnimation } from "../../../../Animation/Animation.jsx";

import styles from "./ModuleList.module.css";

export const ModuleList = ({ data, student }) => {
  const [currentList, setCurrentList] = useState(1);
  const [itemsInList, setItemsInList] = useState(5);

  const indexOfLastItem = currentList * itemsInList;
  const indexOfFirstItem = indexOfLastItem - itemsInList;
  const currentTransactions = data.slice(indexOfFirstItem, indexOfLastItem);
  const numOfMaxList = Math.ceil(data.length / itemsInList);
  if (data.length) {
    return (
      <>
        <SwitchAnimation keyAnimation={currentList + itemsInList}>
          <div className={styles.moduleListWrapper}>
            {currentTransactions.map((module, index) => {
              return (
                <ModuleItem key={index} module={module} student={student} />
              );
            })}
          </div>
        </SwitchAnimation>
        <div className="d-flex mt-2">
          <div className="w-100"></div>
          <Pagination className="w-100 m-0 justify-content-center">
            <Pagination.Prev
              disabled={currentList === 1}
              onClick={() => setCurrentList((prev) => prev - 1)}
            />
            <Pagination.Next
              className="ml-4"
              disabled={currentList === numOfMaxList}
              onClick={() => setCurrentList((prev) => prev + 1)}
            />
          </Pagination>
          <Pagination className="w-100 m-0 mr-2 justify-content-end" size="sm">
            <Pagination.Item
              active={itemsInList === 5}
              onClick={() => {
                setItemsInList(5);
                setCurrentList(1);
              }}
            >
              5
            </Pagination.Item>
            <Pagination.Item
              active={itemsInList === 10}
              onClick={() => {
                setItemsInList(10);
                setCurrentList(1);
              }}
            >
              10
            </Pagination.Item>
            <Pagination.Item
              active={itemsInList === 25}
              onClick={() => {
                setItemsInList(25);
                setCurrentList(1);
              }}
            >
              25
            </Pagination.Item>
          </Pagination>
        </div>
      </>
    );
  } else {
    return <ModuleItem plag />;
  }
};
